const toggleSearchBar = (searchIcon: HTMLElement, searchBar: HTMLElement): void => {
    searchIcon.addEventListener('click', () => {
        // Toggle the visibility of the search icon and search bar
        searchIcon.classList.toggle('hidden');
        searchBar.classList.toggle('hidden');
    
        // Focus on the search input when the search bar is displayed
        if (!searchIcon.classList.contains('hidden')) {
            const searchInput = searchBar.querySelector('input');
            if (searchInput !== null)
            searchInput.focus();
        }
    });
  };